/* eslint-disable max-len */
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {AnalyticEventValue, AnalyticEventCategory, AnalyticEventType, GiftMembershipMethod} from '../../../../../shared/entity_datas/EntityDatas'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {ViewPopupLogin} from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin'
import {navigateToPage, sendToAppropriateMobileStore} from '../../../../shared/scripts/ui_utils/ClientUtils'
import {PrivateAdOptions, UIPrivateAdController} from '../../ui_ad/UIPrivateAdController'
import {setElementInnerHTML, setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {uiManager} from '../../EntryHomepage'
import {userHasAccessToRankedCitiesAndKnights} from '../../../../../shared/matchmaking/MatchmakingUtils'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {TranslationObject} from '@colonist/i18n'
import {HolidayDateUtils, HolidayKey, holidayKey} from '../../../../shared/scripts/HolidayDateUtils'
import LobbyAdSignIn from '@static/images/lobby_ad_signin.svg'
import LobbyAdPlus from '@static/images/lobby_ad_plus.png'
import LobbyAdPremium from '@static/images/lobby_ad_premium.png'
import LobbyAdRanked from '@static/images/lobby_ad_ranked.png'
import LobbyAdCkRanked from '@static/images/lobby_ad_ck_ranked.png'
import LobbyAdMobileApp from '@static/images/lobby_ad_mobile_app.png'
import LobbyAdDiscordLogin from '@static/images/lobby_ad_discordlogin.svg'
import StoreColorBlack from '@static/images/store_color_black.png'
import IconGameMode1V1 from '@static/images/icon_gamemode_1v1.svg'
import IconGift from '@static/images/icon_gift.png'
import IconRewardsProgram from '@static/images/icon_rewards_program.png'
import IconGiftBox from '@static/images/icon_gift_box.svg'
import LobbyAdValentines from '@static/images/lobby_ad_valentines.png'
import LobbyAdEaster from '@static/images/lobby_ad_easter.png'
import LobbyAdHalloween from '@static/images/lobby_ad_halloween.png'
import LobbyAdThanksgiving from '@static/images/lobby_ad_thanksgiving.png'
import LobbyAdChristmas from '@static/images/lobby_ad_christmas.png'
import GameModeCitiesAndKnights from '@static/images/game_mode_icons/cities_and_knights.svg'
import {ImageURL} from '@colonist/types'
import IconTie from '@static/images/icon_tie.svg'
// import LobbyAdChampionship25 from '@static/images/lobby_ad_cc25.png'
import {AudioManager, AudioType} from '@colonist/audio'

export interface PrivateAd extends PrivateAdOptions {
    image: ImageURL
    title: TranslationObject
    description: TranslationObject
    buttonName: TranslationObject
    buttonUrl?: string
    buttonAction?: () => void
    exposure: number
    clickAnalytic: AnalyticEventValue | GiftMembershipMethod
    buttonIcon?: ImageURL
    isLoggedInRequired?: boolean
}

const adTranslationKey = ['discordLogin', 'mobile', 'citiesAndKnightsRanked', 'ranked', 'membership.premium', 'membership.plus', 'signIn', 'membership.elite', 'freeColor', 'playCitiesAndKnights', 'play1v1', 'gifting', 'joinTeam', 'rewardsProgram', ...holidayKey] as const
type AdTranslationKey = (typeof adTranslationKey)[number]

export class UIHomepageAdView {
    private ads: PrivateAd[] = [
        {...UIHomepageAdView.getStringAdData('signIn'), image: LobbyAdSignIn, buttonAction: () => new ViewPopupLogin(), exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdViewSignIn, filterIfLoggedIn: true, filterIfDiscord: true},
        {...UIHomepageAdView.getStringAdData('membership.plus'), image: LobbyAdPlus, buttonUrl: '/store#membership', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdViewMemberships},
        {...UIHomepageAdView.getStringAdData('membership.premium'), image: LobbyAdPremium, buttonUrl: '/store#membership', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdViewMemberships},
        {...UIHomepageAdView.getStringAdData('ranked'), image: LobbyAdRanked, buttonUrl: '/leaderboards', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdViewLeaderboards},
        {...UIHomepageAdView.getStringAdData('citiesAndKnightsRanked'), image: LobbyAdCkRanked, buttonUrl: '/leaderboards/CitiesAndKnights4P', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdViewLeaderboards},
        {...UIHomepageAdView.getStringAdData('mobile'), image: LobbyAdMobileApp, buttonAction: () => sendToAppropriateMobileStore(), exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdDownloadMobile},
        {...UIHomepageAdView.getStringAdData('discordLogin'), image: LobbyAdDiscordLogin, buttonAction: () => UIPrivateAdController.accountLinkingAction(), exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdDiscordLogin, filterIfDiscord: true},
        {...UIHomepageAdView.getStringAdData('joinTeam'), image: IconTie, buttonUrl: '/careers', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdHire},
        {...UIHomepageAdView.getStringAdData('freeColor'), image: StoreColorBlack, buttonUrl: '/store#colors', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdFreeColor},
        {...UIHomepageAdView.getStringAdData('playCitiesAndKnights'), image: GameModeCitiesAndKnights, buttonAction: () => UIHomepageAdView.onClickPlayCK(), exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdPlayCitiesAndKnights},
        {...UIHomepageAdView.getStringAdData('play1v1'), image: IconGameMode1V1, buttonAction: () => uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.UnrankedClassic1v1), exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdPlay1v1},
        {...UIHomepageAdView.getStringAdData('gifting'), image: IconGift, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, isLoggedInRequired: true},
        {...UIHomepageAdView.getStringAdData('rewardsProgram'), image: IconRewardsProgram, buttonUrl: '/store#referrals', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdRewardsProgram},

        // {...UIHomepageAdView.getStringAdData('championship25'), image: LobbyAdChampionship25, buttonUrl: '/championship2025', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdChampionship25},
        // {image: 'game_mode_icons/cities_and_knights.svg', title: 'Cities & Knights', buttonName: 'Get Expansion', buttonUrl: '/store', description: 'Upgrade your cities and use Knights to fight against the Barbarians!', exposure: 3},
        // {image: 'game_mode_icons/56player.svg', title: '5-6 Player', buttonName: 'Get Expansion', buttonUrl: '/store', description: 'Play with up to 6 friends on bigger maps, building in between turns!', exposure: 3},
        // {image: MapEarthPreview, title: 'Earth', buttonName: 'Get Map', buttonUrl: '/store', description: 'Build anywhere around the world! Suitable for all game modes.', exposure: 1},
        // {image: MapShuffleboardPreview, title: 'Shuffle Board', buttonName: 'Get Map', buttonUrl: '/store', description: 'Tiles are arranged in a different pattern each time you play: 1000 different maps possibilities!', exposure: 1},
        // {image: MapBlackForestPreview, title: 'Black Forest', buttonName: 'Get Map', buttonUrl: '/store', description: 'Great map for explorers! Discover what\'s out there building into the fog tiles!', exposure: 1},
        // {image: MapVolcanoPreview, title: 'Volcano', buttonName: 'Get Map', buttonUrl: '/store', description: 'Race towards the gold tile! Discover what the volcano has to offer beneath the fog tiles.', exposure: 1},
        // {image: StoreItemIcons, title: 'Avatars', buttonName: 'Get Avatars', buttonUrl: '/store', description: 'Over a dozen avatars available, and more coming soon!', exposure: 1},
        // {image: StoreItemColors, title: 'Colors', buttonName: 'Get Colors', buttonUrl: '/store', description: 'Color Black is FREE!', exposure: 1},
        // {image: LobbyAdLemr, title: 'Global Leaderboards', buttonName: 'Go to Leaderboards', buttonUrl: '/leaderboards', description: 'Play ranked games to show up on the leaderboards', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdViewLeaderboards},
        // {...UIHomepageAdView.getStringAdData('membership.elite'), image: LobbyAdElite, title: 'Elite Membership', buttonName: 'Become a Member', buttonUrl: '/store#membership', description: '<br>- No ads<br>- Ranked Cities & Knights access<br> - All Maps<br> - All Expansions<br> - All available Colors', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdViewMemberships},
        // {image: IconTie, title: 'Product Manager', buttonName: 'Apply Now!', buttonUrl: '/roles/product', description: '<br>- Clear and logical thinker <br>- Can solve any problem', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdHire},
        // {image: IconRobberCupid, title: 'Recruiter', buttonName: 'Apply Now!', buttonUrl: '/roles/recruiter', description: '<br>- Conscientious <br>- Social <br>- Proactive', exposure: 1, clickAnalytic: AnalyticEventValue.LobbyAdHire},
    ]

    private readonly container: HTMLDivElement
    private readonly image: HTMLImageElement
    private readonly title: HTMLHeadingElement
    private readonly description: HTMLParagraphElement
    private readonly button: HTMLLinkElement

    private holidayAdKey: HolidayKey | undefined
    private isHolidayAdBeingShown = false

    constructor() {
        this.container = document.getElementById(`scene_homepage_ad_container`) as HTMLDivElement
        this.image = document.getElementById(`scene_homepage_store_ad_image`) as HTMLImageElement
        this.title = document.getElementById(`scene_homepage_store_ad_title`) as HTMLHeadingElement
        this.description = document.getElementById('scene_homepage_store_ad_description') as HTMLParagraphElement
        this.button = document.getElementById(`scene_homepage_store_ad_button`) as HTMLLinkElement

        this.setHolidayAdKey()
    }

    hide() {
        if(this.container == undefined) return
        this.container.style.display = 'none'
    }

    show() {
        if(this.container == undefined) return
        this.container.style.display = 'flex'
    }

    update() {
        void this.showDefaultAd()
    }

    private clickAction(event: MouseEvent, adToShow: PrivateAd) {
        event.preventDefault()
        CA.sendGoogleAnalyticsEvent(CA.Category.Lobby, CA.Label.ClickedAdblockAd)
        AudioManager.play(AudioType.Click)

        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: this.isHolidayAdBeingShown ? AnalyticEventCategory.GiftMembershipOverlay : AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: adToShow.clickAnalytic,
        }
        void CA.sendAnalyticEvent(eventData)
        if(adToShow.isLoggedInRequired && !ClientUserState.userState?.isLoggedIn) {
            new ViewPopupLogin()
            return
        }
        if(typeof adToShow.buttonUrl == 'string') {
            navigateToPage(adToShow.buttonUrl, true)
            return
        }
        if(adToShow.buttonAction != undefined) adToShow.buttonAction()
    }

    private async showDefaultAd() {
        const adToShow = await this.getAdToShow()
        this.image.src = adToShow.image
        if(this.button.parentElement != undefined) setElementOnClick(this.button.parentElement, (event: MouseEvent) => this.clickAction(event, adToShow))
        setElementInnerHTML(this.title, adToShow.title)
        if(this.description != undefined) setElementInnerHTML(this.description, adToShow.description)
        setElementInnerHTML(this.button, adToShow.buttonName)
        if(adToShow.buttonIcon) {
            // eslint-disable-next-line no-restricted-syntax
            this.button.innerHTML = `<img src="${adToShow.buttonIcon}">   ${this.button.innerHTML}`
        }
    }

    private async getAdToShow(): Promise<PrivateAd> {
        if(this.shouldShowHolidayAd()) return this.getHolidayAd()

        const newAdList: PrivateAd[] = []
        this.ads = UIPrivateAdController.filterAds(this.ads)
        for(const ad of this.ads) {
            for(let i = 0; i < ad.exposure; i++) {
                newAdList.push(ad)
            }
        }
        return ArrayUtils.randomElementFromArray(newAdList)
    }

    private static getStringAdData(key: AdTranslationKey): {title: TranslationObject, description: TranslationObject, buttonName: TranslationObject} {
        return {
            title: {key: `strings:homePage.colonistAds.${key}.title`},
            description: {key: `strings:homePage.colonistAds.${key}.description`},
            buttonName: {key: `strings:homePage.colonistAds.${key}.buttonName`},
        }
    }

    private static onClickPlayCK() {
        if(!userHasAccessToRankedCitiesAndKnights(ClientUserState.userState?.items, ClientUserState.userState?.ckTotalGameCount, ClientUserState.abTests, ClientUserState.userState?.ckNextRerollAt, ClientUserState.userState?.ckFreeGameUntil)) {
            navigateToPage('/store#membership', true)
            return
        }
        uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedCitiesAndKnights4P)
    }

    private setHolidayAdKey() {
        this.holidayAdKey = HolidayDateUtils.getCurrentHoliday()
    }

    private getHolidayAd(): PrivateAd {
        switch(this.holidayAdKey) {
            case 'valentines': return {...UIHomepageAdView.getStringAdData('valentines'), image: LobbyAdValentines, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, buttonIcon: IconGiftBox, isLoggedInRequired: true}
            case 'easter': return {...UIHomepageAdView.getStringAdData('easter'), image: LobbyAdEaster, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, buttonIcon: IconGiftBox, isLoggedInRequired: true}
            // case 'mothersday': return {...UIHomepageAdView.getStringAdData('mothersday'), image: LobbyAdMothersDay, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, buttonIcon: IconGiftBox, isLoggedInRequired: true}
            // case 'fathersday': return {...UIHomepageAdView.getStringAdData('fathersday'), image: LobbyAdFathersDay, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, buttonIcon: IconGiftBox, isLoggedInRequired: true}
            case 'halloween': return {...UIHomepageAdView.getStringAdData('halloween'), image: LobbyAdHalloween, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, buttonIcon: IconGiftBox, isLoggedInRequired: true}
            case 'thanksgiving': return {...UIHomepageAdView.getStringAdData('thanksgiving'), image: LobbyAdThanksgiving, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, buttonIcon: IconGiftBox, isLoggedInRequired: true}
            case 'christmas': return {...UIHomepageAdView.getStringAdData('christmas'), image: LobbyAdChristmas, buttonUrl: '/store#gift', exposure: 1, clickAnalytic: GiftMembershipMethod.LobbyAd, buttonIcon: IconGiftBox, isLoggedInRequired: true}
            default: throw new Error('holiday ad called without a valid holiday ad key')
        }
    }

    private setHolidayAdClasses() {
        this.isHolidayAdBeingShown ? this.image.classList?.add('homepage-left-holiday-ad') : this.image.classList?.remove('homepage-left-holiday-ad')

        const adContentContainer = this.container.children[0] as HTMLDivElement
        if(adContentContainer == undefined) throw new Error('Wrong HTML structure in homepage-left.ejs')

        this.isHolidayAdBeingShown ? adContentContainer.classList?.add('homepage-holiday-ad-content') : adContentContainer.classList?.remove('homepage-holiday-ad-content')
        this.isHolidayAdBeingShown ? this.button.classList?.add('homepage-holiday-ad-button') : this.button.classList?.remove('homepage-holiday-ad-button')
    }

    private shouldShowHolidayAd(): boolean {
        if(this.holidayAdKey == undefined) return false
        const holidayAdsProbability = 0.5
        this.isHolidayAdBeingShown = Math.random() < holidayAdsProbability
        this.setHolidayAdClasses()
        return this.isHolidayAdBeingShown
    }
}
